interface UserLike {
  name?: string;
  surname?: string;
  email?: string;
}

const AVATAR_COLORS = [
  { bg: "bg-slate-100", text: "text-slate-700" },
  { bg: "bg-stone-100", text: "text-stone-700" },
  { bg: "bg-blue-100", text: "text-blue-800" },
  { bg: "bg-indigo-100", text: "text-indigo-800" },
  { bg: "bg-sky-100", text: "text-sky-800" },
  { bg: "bg-zinc-100", text: "text-zinc-700" },
  { bg: "bg-neutral-100", text: "text-neutral-700" },
  { bg: "bg-gray-100", text: "text-gray-700" },
] as const;

export const getUserInitials = (user: UserLike | undefined): string => {
  if (!user) return "?";

  const name = user.name?.trim() ?? "";
  const surname = user.surname?.trim() ?? "";

  if (name && surname) {
    return `${name[0]}${surname[0]}`.toUpperCase();
  }
  if (name.length >= 2) {
    return name.slice(0, 2).toUpperCase();
  }
  if (name.length === 1) {
    return name.toUpperCase();
  }

  const email = user.email?.trim() ?? "";
  if (email.length >= 2) {
    return email.slice(0, 2).toUpperCase();
  }
  if (email.length === 1) {
    return email.toUpperCase();
  }

  return "?";
};

export const getUserAvatarColor = (identifier: string): { bg: string; text: string } => {
  if (!identifier) return AVATAR_COLORS[0];

  let hash = 0;
  for (let i = 0; i < identifier.length; i++) {
    hash += identifier.charCodeAt(i);
  }
  return AVATAR_COLORS[hash % AVATAR_COLORS.length];
};

export const getUserDisplayName = (user: UserLike | undefined): string => {
  if (!user) return "Unknown user";

  const fullName = [user.name, user.surname].filter(Boolean).join(" ").trim();
  if (fullName) return fullName;

  const email = user.email?.trim();
  if (email) return email;

  return "Unknown user";
};
